export class ApiResponseError {
    error: {
        message: string;
        type: string;
    };

    status_code: number;
}
